export default ({
  GET_VICTIM_LIST_REQUEST: "GET_VICTIM_LIST_REQUEST",
  GET_VICTIM_LIST_SUCCESS: "GET_VICTIM_LIST_SUCCESS",
  GET_VICTIM_LIST_FAILURE: "GET_VICTIM_LIST_FAILURE",
  GET_VICTIM_VIEW_REQUEST: 'GET_VICTIM_VIEW_REQUEST',
  GET_VICTIM_VIEW_SUCCESS: 'GET_VICTIM_VIEW_SUCCESS',
  GET_VICTIM_VIEW_FAILURE: 'GET_VICTIM_VIEW_FAILURE',
  });